import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./locales/fr.json";
import en from "./locales/en.json";
import es from "./locales/es.json";

export const SUPPORTED_LANGS = ["fr", "en", "es"];

i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, en: { translation: en }, es: { translation: es } },
  lng: localStorage.getItem("pp_lang") || "fr",
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export default i18n;
